import { cn } from '@repo/ui'
import React, { type PropsWithChildren } from 'react'

import { getMorphoChainSlug } from '../utils/chain.utils'

type MorphoLinkProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & {
  chainId: number
  marketId: string
} & PropsWithChildren

export function MorphoLink(props: MorphoLinkProps) {
  const { marketId, chainId, className, children, ...rest } = props

  return (
    <a
      target="_blank"
      className={cn(className, 'hover:underline')}
      aria-label="Link to the Morpho app for this market"
      rel="noopener noreferrer"
      href={`https://app.morpho.org/${getMorphoChainSlug(chainId)}/market/${marketId}`}
      {...rest}
    >
      {children}
    </a>
  )
}
